"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AUTH = exports.USER_AUTHS = void 0;
const route_1 = require("../route");
exports.USER_AUTHS = route_1.PROJECT.sub("/userAuths");
exports.USER_AUTH = route_1.PROJECT.sub("/userAuths/:email");
